import { useStateRef } from '@/pages/ISWAN_CHAT/hooks/useStateRef/useStateRef';
import { AIType } from '@/pages/ISWAN_CHAT/interface';

export default () => {
  const [aiType, setAiType, aiTypeRef] = useStateRef<AIType | null>('Chat');

  return [aiType, setAiType, aiTypeRef] as [AIType | null, typeof setAiType, typeof aiTypeRef];
};
